<template>
  <nav class="pk-footer-network" aria-label="友情链接与支付支持">
    <section class="pk-footer-network-group">
      <strong class="pk-footer-network-title">友情链接</strong>
      <div class="pk-footer-network-list">
        <a
          v-for="link in friendLinks"
          :key="link.name"
          :href="link.href"
          target="_blank"
          rel="noopener noreferrer"
          :title="`前往${link.name}官方网页`"
          :aria-label="`前往${link.name}官方网页`"
        >
          <span class="pk-footer-network-mark" :class="{ wide: link.mark.length > 1 }">{{ link.mark }}</span>
          <span>{{ link.name }}</span>
        </a>
      </div>
    </section>

    <section class="pk-footer-network-group pk-footer-payment-group">
      <strong class="pk-footer-network-title">支付支持</strong>
      <div class="pk-footer-network-list">
        <a
          v-for="link in paymentLinks"
          :key="link.name"
          :href="link.href"
          :target="link.external ? '_blank' : null"
          :rel="link.external ? 'noopener noreferrer' : null"
          :title="link.external ? `前往${link.name}官方网页` : '前往站内礼品卡'"
          :aria-label="link.external ? `前往${link.name}官方网页` : '前往站内礼品卡'"
        >
          <span class="pk-footer-network-mark">{{ link.mark }}</span>
          <span>{{ link.name }}</span>
        </a>
      </div>
    </section>
  </nav>
</template>

<script>
export default {
  name: "FooterFriendLinks",
  data() {
    return {
      friendLinks: [
        { name: "Steam", mark: "S", href: "https://store.steampowered.com/" },
        { name: "UU加速器", mark: "UU", href: "https://uu.163.com/" },
        { name: "网易BUFF", mark: "B", href: "https://buff.163.com/" },
        { name: "悠悠有品", mark: "U", href: "https://www.youpin898.com/" },
        { name: "微博", mark: "微", href: "https://weibo.com/" },
        { name: "微信", mark: "W", href: "https://www.tencent.com/zh-cn/products/weixin-wechat/" },
        { name: "QQ", mark: "Q", href: "https://im.qq.com/" },
        { name: "抖音", mark: "抖", href: "https://www.douyin.com/" },
        { name: "快手", mark: "快", href: "https://www.kuaishou.com/" },
        { name: "视频号", mark: "视", href: "https://channels.weixin.qq.com/" },
        { name: "哔哩哔哩", mark: "B", href: "https://www.bilibili.com/" },
      ],
      paymentLinks: [
        { name: "支付宝", mark: "支", href: "https://www.alipay.com/", external: true },
        { name: "银联", mark: "银", href: "https://www.unionpay.com/", external: true },
        { name: "微信支付", mark: "微", href: "https://pay.wechatpay.cn/", external: true },
        { name: "礼品卡", mark: "礼", href: "#/Payment", external: false },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.pk-footer-network {
  width: 100%;
  padding-top: 14px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  box-sizing: border-box;
}

.pk-footer-network-group,
.pk-footer-network-list,
.pk-footer-network a {
  display: flex;
  align-items: center;
}

.pk-footer-network-group {
  min-width: 0;
  gap: 12px;
}

.pk-footer-payment-group {
  justify-content: flex-end;
}

.pk-footer-network-title {
  flex: 0 0 auto;
  color: #5f687a;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.pk-footer-network-list {
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

.pk-footer-network a {
  min-height: 28px;
  padding: 0 8px 0 5px;
  gap: 6px;
  color: #858fa1;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease, transform 160ms ease;
}

.pk-footer-network a:hover,
.pk-footer-network a:focus-visible {
  color: #ffd266;
  background: rgba(255, 138, 22, 0.08);
  border-color: rgba(255, 174, 48, 0.28);
  outline: none;
  transform: translateY(-1px);
}

.pk-footer-network-mark {
  width: 19px;
  height: 19px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #c5ccda;
  background: #262a38;
  border: 1px solid #3a4050;
  border-radius: 50%;
  box-sizing: border-box;
  font-size: 9px;
  font-weight: 1000;
  letter-spacing: -0.04em;
}

.pk-footer-network-mark.wide {
  width: 24px;
  border-radius: 10px;
}

.pk-footer-network a:hover .pk-footer-network-mark,
.pk-footer-network a:focus-visible .pk-footer-network-mark {
  color: #191b26;
  background: #ffab2e;
  border-color: #ffbf54;
}

@media screen and (max-width: 1180px) {
  .pk-footer-network {
    grid-template-columns: 1fr;
  }

  .pk-footer-payment-group {
    justify-content: flex-start;
  }
}

@media screen and (max-width: 560px) {
  .pk-footer-network {
    padding-top: 16px;
    gap: 14px;
  }

  .pk-footer-network-group {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .pk-footer-network-list {
    width: 100%;
  }

  .pk-footer-network a {
    min-height: 32px;
  }
}
</style>
